export const nav = [
    {
        text: "Home",
        path: "/",
    },
    {
        text: "About",
        path: "/about",
    },
    {
        text: "Pricing",
        path: "/pricing",
    },
    {
        text: "Contact",
        path: "/contact",
    },
    // {
    //     text: "order",
    //     path: "https://wa.me/+27646122609",
    // }
    
]

export const togglenav = [
  {
      text: "home",
      path: "/",
  },
  {
      text: "about",
      path: "/about",
  },
  {
      text: "pricing",
      path: "/pricing",
  },
  {
      text: "contact",
      path: "/contact",
  },
  {
      text: "order",
      path: "https://wa.me/+27646122609",
  }
  
]

export const featured = [
    {
        cover: "../images/hero/h1.jpeg",
        name: "Forest Green",
        // total: "122 Property",
    },
    {
        cover: "../images/hero/h2.jpeg",
        name: "Plum rose",
        // total: "155 Property",
    },
    {
        cover: "../images/hero/h3.jpeg",
        name: "Red velvet",
        // total: "300 Property",
    },
    {
        cover: "../images/hero/h4.jpeg",
        name: "Touch of Gold",
        // total: "80 Property",
    },
]

export const collection= [
  {
      image: "../images/slide/red/r1.jpeg",
      name: "",
  },
  {
    image: "../images/tradition/t7.jpg",
    name: "",
  },
  {
    image: "../images/slide/green/g2.jpeg",
    name: "",
  },
  {
    image: "../images/tradition/t4.jpg",
    name: "",
  },
  {
    image: "../images/slide/green/g1.jpeg",
    name: "",
  },
  {
    image: "../images/o1.jpeg",
    name: "",
  },
  {
    image: "../images/roof.jpeg",
    name: "",
  },
  {
    image: "../images/tradition/t5.jpg",
    name: "",
  },
]

export const list = [
    {
      id: 1,
      cover: "../images/list/h1.jpeg",
      name: "Garden of Gold Accents",
      // description: "Description and details here",
      // category: " ",
      // price: "2 742",
    },
    {
      id: 2,
      cover: "../images/list/h3.jpeg",
      name: "Royal Ruby Bliss",
      // description: "10 tables",
      // category: "Special",
      // price: "5 860",
    },
    {
      id: 3,
      cover: "../images/list/h2.jpeg",
      name: "Pink and Gold Glam",
    },
    {
      id: 4,
      cover: "../images/tradition/t7.jpg",
      name: "Bapedi Tradition",
    },
]

export const price = [
    {
      plan: "Package 1A",
      price: "R15 000",
      // ptext: "A4, per month",
      list: [
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {change: "color",icon: <i class='fa-solid fa-x'></i>,text: "",},
        {change: "color",icon: <i class='fa-solid fa-x'></i>,text: "",},
        {change: "color",icon: <i class='fa-solid fa-x'></i>,text: "",},
      ],
    },
    {
      plan: "Package 2A",
      price: "R20 000",
      // ptext: "A4, per month",
      list: [
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {change: "color",icon: <i class='fa-solid fa-x'></i>,text: "",},
        {change: "color",icon: <i class='fa-solid fa-x'></i>,text: "",},
      ],
    },
    {
      best: "Best Value",
      plan: "Package 2",
      price: "R30 000",
      // ptext: "A4, 50 People",
      list: [
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {change: "color",icon: <i class='fa-solid fa-x'></i>,text: "",},
      ],
    },
    {
      plan: "Package 3",
      price: "R50 000",
      // ptext: "A5, 100 People",
      list: [
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
        {icon: <i class='fa-solid fa-check'></i>,text: "",},
      ],
    },
]

export const contact = [
  {
    icon: "fa fa-map-marker-alt",
    name: "Address",
    details: "Stand No. B0039 Dichoueng, Jane Furse, 1085",
    link: "https://g.co/kgs/Gdq3zUv"
    // link: "http://maps.google.com/maps?q=210+Louise+Ave,+Nashville,+TN+37203"
  },
  {
    icon: "fa fa-phone-alt",
    name: "Phone",
    details: "064 612 2609",
    link: "tel:064 612 2609"
  },
  {
    icon: "fa fa-comment",
    name: "Chat",
    details: "064 612 2609",
    link: "https://wa.me/c/27646122609"
  },
  {
    icon: "fa fa-envelope",
    name: "Email",
    details: "nkadimengmmakwele@gmail.com",
    link: 'mailto:nkadimengmmakwele@gmail.com'
  }
]

export const socials = [
  {
    icon: "fa fa-map-marker-alt",
    image: "../images/socials/instagram.jpeg",
    link: "https://www.instagram.com/metadecorevents"
  },
  {
    icon: "fa fa-map-marker-alt",
    image: "../images/socials/facebook.png",
    link: ""
  },
  {
    icon: "fa fa-map-marker-alt",
    image: "../images/socials/tiktok.jpeg",
    link: "https://www.tiktok.com/@metadecorevents"
  },
  {
    icon: "fa fa-map-marker-alt",
    image: "../images/socials/whatsapp.png",
    link: "https://wa.me/c/27646122609"
  },
  {
    image: "../images/socials/gmail.png",
    link: "mailto:nkadimengmmakwele@gmail.com"
  }
]

export const slides = [
  {
    src: "../images/slide/red/r1.jpeg",
  },
  {
    src: "../images/tradition/t7.jpg",
  },
  {
    src: "../images/slide/green/g2.jpeg",
  },
  {
    src: "../images/tradition/t4.jpg",
  },
  {
    src: "../images/o1.jpeg",
  },
  {
    src: "../images/slide/green/g1.jpeg",
  },
  {
    src: "../images/tradition/couch.jpg",
  },
  {
    src: "../images/tradition/t5.jpg",
  },
  {
    src: "../images/tradition/t-deco.jpg",
  },
  {
    src: "../images/tradition/cute-table.jpg",
  },
  {
    src: "../images/slide/table.jpeg",
  },
]